import SizeGuide from '../../../components/organisms/sizeGuide/SizeGuide';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

const SizeGuideBaseTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  const { label, lineItems, name, subTitle, title } = data;

  const dispatch = useDispatch();

  const setShowDialog = useCallback(() => {
    dispatch({ type: 'close-sizeguide' });
  }, [dispatch]);

  return (
    <SizeGuide
      label={label}
      title={title}
      description={subTitle}
      tableTitle={name}
      table={lineItems}
      showDialog={false}
      setShowDialog={setShowDialog}
    />
  );
};

export default tastify({
  translate: true,
  connect: {
    context: true,
  },
})(SizeGuideBaseTastic);
